/*
 * Papiro · los gestos del menú lateral (sections/menu-lateral.liquid):
 * plegar a iconos en el ordenador, el cajón de la hamburguesa en el móvil y el
 * número del carrito. Todo con delegación, para que siga funcionando cuando el
 * editor de Shopify vuelve a pintar la sección.
 */
(function () {
  'use strict';
  // Ojo: window.papiroRail ya existe (es el <aside id="papiroRail">); la marca va aparte
  if (window.papiroMenuListo) return;
  window.papiroMenuListo = true;

  var root = document.documentElement;
  var KEY = 'papiroRailCollapsed';
  var movil = window.matchMedia('(max-width: 989px)');
  var scrollGuardado = 0;

  function velo() { return document.querySelector('.papiro-rail__velo'); }
  function hamburguesas() { return document.querySelectorAll('[data-papiro-rail-abrir]'); }

  // ── Plegar y desplegar (ordenador) ──
  function pliega(plegado) {
    root.classList.toggle('papiro-rail-collapsed', plegado);
    try { localStorage.setItem(KEY, plegado ? '1' : '0'); } catch (e) {}
    marcaPlegado();
  }
  function marcaPlegado() {
    var plegado = root.classList.contains('papiro-rail-collapsed');
    document.querySelectorAll('[data-papiro-toggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', plegado ? 'false' : 'true');
    });
  }

  // ── El cajón del móvil ──
  function abierto() { return root.classList.contains('papiro-rail-abierto'); }
  function abre() {
    if (!movil.matches || abierto()) return;
    scrollGuardado = window.scrollY || 0;
    var v = velo();
    if (v) v.hidden = false;
    root.classList.add('papiro-rail-abierto');
    // iOS no respeta overflow:hidden en el cuerpo: se fija de verdad
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollGuardado + 'px';
    document.body.style.width = '100%';
    hamburguesas().forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var x = document.querySelector('.papiro-rail__cerrar');
    if (x) setTimeout(function () { x.focus({ preventScroll: true }); }, 60);
  }
  function cierra(devolverFoco) {
    if (!abierto()) return;
    root.classList.remove('papiro-rail-abierto');
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollGuardado);
    hamburguesas().forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    var v = velo();
    if (v) setTimeout(function () { if (!abierto()) v.hidden = true; }, 300);
    if (devolverFoco) {
      var h = document.querySelector('[data-papiro-rail-abrir]');
      if (h) h.focus({ preventScroll: true });
    }
  }

  // Abre un bloque (Tienda o un grupo) y lo que lleva dentro
  function abreBloque(id) {
    var d = document.getElementById(id);
    if (!d) return;
    d.open = true;
    var g = d.querySelector('details.papiro-rail__grupo');
    if (g) g.open = true;
    return d;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    if (t.closest('[data-papiro-toggle]')) {
      pliega(!root.classList.contains('papiro-rail-collapsed'));
      return;
    }
    var ir = t.closest('[data-papiro-ir]');
    if (ir) {
      pliega(false);
      var d = abreBloque(ir.getAttribute('data-papiro-ir'));
      if (d) {
        var s = d.querySelector('summary');
        if (s) s.focus({ preventScroll: true });
      }
      return;
    }
    if (t.closest('[data-papiro-rail-abrir]')) { e.preventDefault(); abre(); return; }
    if (t.closest('[data-papiro-rail-cerrar]')) { e.preventDefault(); cierra(true); return; }
    // Al tocar un enlace del menú, el cajón se cierra solo
    if (abierto() && t.closest('.papiro-rail a[href]')) cierra(false);
    // «Escríbenos» dentro del cajón: se cierra el cajón y se abre el chat
    if (abierto() && t.closest('.papiro-rail [data-papiro-msg-abrir]')) cierra(false);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && abierto()) cierra(true);
  });
  window.addEventListener('pageshow', function () { cierra(false); });
  var alCambiar = function () { if (!movil.matches) cierra(false); };
  if (movil.addEventListener) movil.addEventListener('change', alCambiar);
  else if (movil.addListener) movil.addListener(alCambiar);

  // ── En el editor de Shopify: al elegir la sección se ve la cabecera del móvil
  //    tal cual; al elegir uno de sus bloques (Catálogo, Páginas…), se abre el menú ──
  document.addEventListener('shopify:section:deselect', function (e) {
    if (e.target && e.target.querySelector && e.target.querySelector('#papiroRail')) cierra(false);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var b = e.target;
    if (!b || !b.closest || !b.closest('#papiroRail')) return;
    root.classList.remove('papiro-rail-collapsed'); // sin guardarlo: es solo para verlo
    abre();
    if (b.id) abreBloque(b.id);
    // Que se vea el bloque elegido aunque esté abajo del todo del menú
    setTimeout(function () { try { b.scrollIntoView({ block: 'nearest' }); } catch (x) {} }, 60);
  });
  document.addEventListener('shopify:section:load', marcaPlegado);

  // ── En el editor, al repintarse el menú (cambiar un ajuste, quitar o poner un
  //    bloque con el ojo) se queda como estaba: lo que tenías abierto sigue abierto y
  //    en el mismo sitio, para que se vea el cambio. Lo marcado para no abrirse
  //    («nunca», «ninguna») se respeta. Fuera del editor esto no hace nada. ──
  var recuerdo = null;
  function claves(rail) {
    var vistas = {};
    return Array.prototype.map.call(rail.querySelectorAll('details'), function (d) {
      var s = d.querySelector('summary');
      var t = (s ? s.textContent : '').replace(/\s+/g, ' ').trim();
      vistas[t] = (vistas[t] || 0) + 1;
      return { d: d, clave: t + '#' + vistas[t] };
    });
  }
  document.addEventListener('shopify:section:unload', function (e) {
    var rail = e.target && e.target.querySelector && e.target.querySelector('#papiroRail');
    if (!rail) return;
    var sc = rail.querySelector('.papiro-rail__scroll');
    recuerdo = {
      abiertos: claves(rail).filter(function (x) { return x.d.open; }).map(function (x) { return x.clave; }),
      scroll: sc ? sc.scrollTop : 0
    };
  });
  document.addEventListener('shopify:section:load', function (e) {
    var rail = e.target && e.target.querySelector && e.target.querySelector('#papiroRail');
    if (!rail || !recuerdo) return;
    var r = recuerdo;
    recuerdo = null;
    claves(rail).forEach(function (x) {
      if (r.abiertos.indexOf(x.clave) >= 0 && !x.d.hasAttribute('data-cerrado')) x.d.open = true;
    });
    var sc = rail.querySelector('.papiro-rail__scroll');
    if (sc) sc.scrollTop = r.scroll;
  });

  // Modelos automáticos: una sola subfamilia abierta, también en navegadores
  // que todavía no agrupan <details name>. La ficha visible decide el activo.
  var ultimoModelo = null;
  function marcaModelos(forzar) {
    var rail = document.getElementById('papiroRail');
    if (!rail) return;
    var ficha = document.querySelector('[data-papiro-producto]');
    var handle = ficha ? ficha.getAttribute('data-papiro-producto') : '';
    if (!handle && /\/products\/[^/]+/.test(location.pathname)) handle = location.pathname.split('/products/')[1].split('/')[0];
    var actual = null;
    rail.querySelectorAll('[data-papiro-modelo]').forEach(function (a) {
      var rama = a.closest('[data-papiro-modelos]');
      var coincide = a.getAttribute('data-papiro-modelo') === handle &&
        (rama.getAttribute('data-papiro-modelos') === location.pathname || /\/products\//.test(location.pathname));
      a.classList.toggle('now', coincide);
      if (coincide) { a.setAttribute('aria-current', 'page'); if (!actual) actual = a; }
      else a.removeAttribute('aria-current');
    });
    var clave = location.pathname + ':' + handle;
    if (actual && (forzar || clave !== ultimoModelo)) {
      var rama = actual.closest('[data-papiro-modelos]');
      rail.querySelectorAll('[data-papiro-modelos]').forEach(function (d) { d.open = d === rama; });
      for (var d = rama.parentElement.closest('details'); d; d = d.parentElement ? d.parentElement.closest('details') : null) {
        if (!d.hasAttribute('data-cerrado')) d.open = true;
      }
    }
    ultimoModelo = clave;
  }
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (!d.matches || !d.matches('[data-papiro-modelos]') || !d.open) return;
    document.querySelectorAll('[data-papiro-modelos]').forEach(function (otro) { if (otro !== d) otro.open = false; });
  }, true);
  ['pcfg:ready', 'pcfg:quote', 'papiro:pagina-cambiada'].forEach(function (ev) {
    document.addEventListener(ev, function () { marcaModelos(false); });
  });
  document.addEventListener('shopify:section:load', function () { marcaModelos(true); });
  window.addEventListener('pageshow', function () { marcaModelos(true); });
  marcaModelos(true);

  // ── El número del carrito: al cargar, al volver a la pestaña y tras añadir ──
  function pinta(n) {
    document.querySelectorAll('[data-papiro-cart-count]').forEach(function (b) {
      b.textContent = n;
      b.hidden = !(n > 0);
    });
  }
  function mira() {
    if (!window.fetch) return;
    fetch((window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { pinta(c.item_count || 0); })
      .catch(function () {});
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) mira(); });
  // Horizon avisa cuando cambia el carrito (añadir, quitar, cantidades)
  ['cart:update', 'cart:add'].forEach(function (ev) { document.addEventListener(ev, function () { setTimeout(mira, 300); }); });

  // Los iconos del carrito del menú abren el cajón del carrito de Horizon (si está)
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.papiro-topbar a[href$="/cart"], .p-barra-movil a[href$="/cart"]');
    if (!a) return;
    var cajon = document.querySelector('cart-drawer-component');
    if (cajon && typeof cajon.open === 'function') { e.preventDefault(); cierra(false); cajon.open(); }
  });
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('form[action*="/cart/add"] [type="submit"], [name="add"], [data-add-to-cart]')) {
      setTimeout(mira, 900);
      setTimeout(mira, 2500);
    }
  });

  marcaPlegado();
  window.papiroMenu = { abre: abre, cierra: cierra, pliega: pliega };
})();
